import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class EditOccurrence extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			emp : '',
			ocdate : '',
			remark : '',
			posts : [],
			_redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		
		if(this.state.emp && this.state.ocdate && this.state.remark){
			$("#showLoader").show();
			console.log(this.state);
			PostData('academic/updateoccu',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Occurrence Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					document.getElementById("subform").reset();
				}
				else{
			
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getemployee();
		this.getdetails();
	}
	
	/** get Employee **/
	getemployee(){
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});	  
	}
	
	/** get Occurrence By id **/
	getdetails(){
	  $("#showLoader").show();
		GetData('academic/getoccubyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					emp : res[0]['employee'],
					ocdate : res[0]['date'],
					remark: res[0]['remarks']
				});
			}
		});	
	}
	
  render() {
	
	var items = this.state.posts;
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/academic/occurrence/register' />);
	}
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="6">
					<Card>
					  <form action="" method="post" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Edit Occurrence</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Back</Button>
							</span>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
								  <select name="emp" onChange={this.onChange} className="form-control" id="clas" required value={this.state.emp}> 
									<option value="">Select Employee</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.empname}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Date <span className="text-danger">*</span></Label>
								  <Input type="date" name="ocdate" required onChange={this.onChange} value={this.state.ocdate} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Remarks <span className="text-danger">*</span></Label>
								  <Input type="textarea" name="remark" required onChange={this.onChange} rows="5" value={this.state.remark}/>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default EditOccurrence;


// WEBPACK FOOTER //
// ./src/occurrence/Occurrence/EditOccurrence.js